<template>
    <div class="motionSection reveal" ref="circontents">

        <div class="stickySec">
            <div class="sectionTitle black fsTitle stLeft">
                <span class="stLine reveal"></span>
                <splitter :content="localize(sectionData.title)"></splitter>                
            </div>
            
            <div class="tlIcons">
                
                <div class="icons first">
                    <img :src="getSvgLine()">
                </div>
                <div class="icons" :style="'--prec:'+linePrec">
                    <img :src="getSvgLine()">
                </div>                
                
                <div class="tlInfos">
                    <div v-for="(item,pointIndex) in sectionData.items" 
                        :style="getInfoPos(pointIndex)"
                        :class="['tlInfo',currentIndex < pointIndex ? '' : 'active',currentIndex==pointIndex ? '':'mHide']"
                        :key="pointIndex">
                        <div class="tlText tlNum">0{{pointIndex+1}}</div>
                        <div class="tlText tlTitle">{{localize(sectionData.items[pointIndex].title)}}</div>
                        <div class="tlText tlDesc">{{localize(sectionData.items[pointIndex].content)}}</div>
                    </div>
                </div>
            </div>

            <!--
            <div class="timeline">
                <div class="line">
                    <div class="linefill" :style="getLineStyle()"></div>
                    <div v-for="(item,pointIndex) in sectionData.items" 
                        :style="getPointPos(pointIndex)" :key="pointIndex" 
                        :class="['linepoint',currentIndex < pointIndex ? '' : 'active']">
                        <div class="ring"></div>
                        <div class="point"></div>                        
                    </div>
                    <div v-for="(item,nameIndex) in sectionData.items" 
                        :style="getPointPos(nameIndex)" :key="nameIndex" 
                        :class="['pointname',currentIndex < nameIndex ? '' : 'active']">Step {{nameIndex+1}}</div>
                </div>
            </div>
            <div class="tlContent">
                <div class="tlItemTitle">{{localize(sectionData.items[currentIndex].title)}}<br/></div>
                <div class="fsText">
                    {{localize(sectionData.items[currentIndex].content)}} 
                </div>
            </div>
            -->

        </div>
    </div>
</template>

<style scoped>

      .stickWrap
      {
        position:initial;
        display: block;
        height:300vh;        
      }
      .stickInner
      {
        height: 100vh;
        top: 0;
        position: sticky;
        border: solid 10px red;
      }


  .motionSection
  {    
    height: 300vh;
  }
  .stickySec
  {
    height: 100vh;
    top: 0;
    position: sticky;

    display: flex;
    /* overflow: visible; */
    
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }

    .tlIcons
    {        
        width: 70vw;height: 200px;
        margin: auto;display: flex;
        align-content: center;align-items: center;
        position: relative;
    }
    .motionSection .tlIcons .icons:nth-child(1)
    {
        width: 100%;
        position: absolute;        
        filter: grayscale(100%);
        clip-path: inset(0% 100% 0% 0%);
        transition: all ease 1s;
        transition-delay: 1s;
        opacity: 0;
    }
    .motionSection.active .tlIcons .icons:nth-child(1)
    {
        clip-path: inset(0% 0% 0% 0%);
        opacity: 0.3;
    }

    .motionSection .tlIcons .icons:nth-child(2)
    {
        width: 100%;
        position: absolute;
        clip-path: inset(0% var(--prec) 0% 0%);
        transition: all ease 0.3s;
    }



    .tlInfos
    {
        position: relative;
        width: 100%;
    }
    .tlInfo
    {
        position: absolute;
        top: 50px;        
        width: 15vw;
        height: 150px;
        /* border-left: solid 1px #bebebe; */
        text-align: left;
        /* padding-left: 20px; */
        align-content: center;
/*         opacity: 1;
        transition: all ease 0.4s;
 */        /* transform: translateX(-50%); */
    }
    .tlInfo.active
    {
        opacity: 1;
    }
    .tlInfo .tlText
    {
        transition: all ease 0.6s;
        opacity: 0;
        transform: translateY(25px);
    }
    .tlInfo.active .tlText
    {
        transform: translateY(0px);
        opacity: 1;
    }
    .tlInfo .tlNum{
        font-size: 40px;
        color: var(--blue-main);
        font-weight: 600 !important;
        transition-delay: 0.1s;
    }
    .tlInfo .tlTitle{
        padding-top: 4px;
        font-size: 18px;color: #3c3c3c;
        font-weight: 600 !important;
        transition-delay: 0.2s;
    }
    .tlInfo .tlDesc{
        padding-top: 6px;
        font-size: 16px;color: #3c3c3c;
        transition-delay: 0.3s;
    }


    .timeline
    {
        /* display: flex; */
        display: none;
        width: 40vw;height: 200px;
        margin: auto;
        
        align-content: center;align-items: center;
    }
    .timeline .line
    {
        position: relative;
        width: 100%;height: 3px;
        background-color: #bebebe;
    }
    .linefill
    {
        background-color: var(--blue-main);        
        position: absolute;top: 0px;left: 0px;height: 3px;
        width: 0%;
        transition: all ease 0.1s;
    }
    .linepoint
    {        
        position: absolute;top: 50%;
        transform: translate(-50%,-50%);
    }
    .linepoint .point
    {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: var(--blue-main);
        position: absolute;top: -5px;left: -5px;
        transition: all ease 0.4s;        
    }
    .linepoint.active .point
    {
        background-color: var(--green);
    }    
    .linepoint .ring
    {
        width: 22px;
        height: 22px;
        border-radius: 100%;
        background-color:#fff;
        border: solid 2px var(--blue-main);
        position: absolute;top: -11px;left: -11px;
        opacity: 0;
        transition: all ease 0.4s;
        transform: scale(0.1);
    }
    .linepoint.active .ring
    {
        opacity: 1;
        transform: scale(1);
    }
    .pointname
    {
        position: absolute;
        font-size: 20px;
        color: var(--blue-main);
        font-weight: 600;
        white-space: nowrap;
        opacity: 0.4;
        transition: all ease 0.4s;
    }
    .pointname.active
    {
        opacity: 1;
    }
    .pointname:nth-of-type(odd)
    {
        /* align label below point */        
        transform: translateX(-50%);
        /* transform: translate(calc(-50% - 10px),100%) /* rotate(-90deg) */
        transform-origin: top center;top: 25px;
    }
    .pointname:nth-of-type(even)
    {
        transform: translateX(-50%);
        /* align label above point */
        /* transform: translate(calc(-50% + 10px),-100%) /* rotate(-90deg) */
        transform-origin: bottom center;bottom: 25px;
    }
    .tlContent
    {
        clear: both;
        position: absolute;
        display: block;
        top: calc(50vh + 100px);
        width: 40vw;
        padding-top: 20px;     
        color: #202020;     
        display: none;  
    }
    .tlItemTitle
    {
        font-size: 30px;
        font-weight: 500;
        padding-bottom: 5px;
    }
    .tlItemText
    {
        font-size: 22px;
    }


.section-title
{
    font-size: 40px;
    text-align: center;
    color: #fff;
    letter-spacing: 0px;
}

@media (orientation: portrait) {
    .tlIcons
    {
        width: 80vw;
    }
    .motionSection .tlIcons .icons
    {
        display: initial;
        left: 0px;
        top: 60px;        
        width: auto
    }
    .tlInfo{
        width: calc(100vw - 200px);
        left: 100px !important;        
        top: 0px;
    }  
    .motionSection .tlIcons .icons:nth-child(2)
    {
        clip-path: inset(0% 0% var(--prec) 0%);
    }

}
@media (orientation: landscape) {
}



    @media (min-width: 850px) { 
    }

    @media (max-width: 850px) {         
        .stickySec
        {
            display: block;
        }
        .tlIcons
        {
            display: block;
            padding-top: 30px;            
        }
        
        .motionSection .tlIcons .icons{
            top: 50px !important;
        }        
        .motionSection .tlIcons .icons img{
            height: 70vh;
            width: auto;
        }        

        .tlInfo
        {
            top: calc(1vh + (15.5vh * var(--index)));
            transition: all ease 0.3s;
            width: calc(100vw - 160px);
            left: 85px !important;
        }
        .tlInfo .tlNum{
            font-size: 30px;
            display: none;
        }
        .tlInfo .tlTitle
        {
            font-size: 22px !important;
            line-height: 30px !important;            
        }
        .tlInfo .tlDesc
        {
            font-size: 20px;
        }

        /* mobile specific, hide the content ? */
        .tlInfo.mHide
        {
            /* opacity: 0 !important; */
        }


    }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>

<script>
import { mapActions, mapState } from "vuex";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { splitter },
    data()
    {
        return{
            linePrec:'100%',
            currentIndex:-1,
            lineWidth:0,
            sectionProgress:0,
            arrTextH:[],
            secIndex:1,
            selectedIndex:0,
            elementTitle:'',
            elementDesc:'',            
            sizerTitle:'',
            sizerContent:'',
            maxTextHeight:0,
            intChanger:Object,
            isAutoChanging:false,
            styles:[]
        }
    },
    props:{
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted()
    {
        let vm = this;
        setTimeout(() => {
            //vm.collectHeights();
        }, 500);
    },
    destroyed() {
        //this.removeImgScroller();
    },
    computed: {
        ...mapState(["xSelectedPlatform","siteData","siteDataReady","siteVisibleSection"]),
        sectionData()
        {
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
    },
    watch: {
        //sectionScrollProg
        '$store.state.sectionScrollProg': function() {
            //alert("updatung");
            //alert(this.sectionDataIndex);
            if(this.sectionScrollProg.index==this.sectionDataIndex)
            {
                this.updateStyles();
            }
        },
      '$store.state.siteVisibleSection': function() {
        var vm=this;        
        let _siteVisibleSection = this.$store.state.siteVisibleSection;        
        if(_siteVisibleSection==this.sectionDataIndex+1){
            //alert("start auto timer");
            //start the timer
            if(isMobileScreen()==false){
                //vm.startAutoChange();
            }
        }else
        {
            //vm.stopAutoChange();
        }
      }
    },

    methods:
    {
        getSvgLine()
        {
            
            var isHorizontal = true;
            if(window.innerHeight > window.innerWidth){
                isHorizontal = false;
            }
            
            if(isHorizontal){
                return 'content/mguide/img/svg/workflow_hor.svg';
            }else{
                return 'content/mguide/img/svg/workflow_ver.svg';
            }
        },
        collectHeights()
        {
            let vm =this;
            vm.style = [];
            vm.arrTextH = [];
            let items = vm.$el.querySelectorAll(".bnItemDesc");
            for (var i = 0; i < items.length; i++) 
            {
                let br = items[i].getBoundingClientRect();
                vm.arrTextH.push(br.height);

                let itemStyle = {
                    textH:0,
                    alpha:0.5
                };
                vm.styles.push(itemStyle);
            }
            vm.updateStyles();
        },
        updateStyles()
        {
            //console.log("this.lineWidth="+this.lineWidth);
            let secProg = this.sectionScrollProg.prog; //0-1
            this.lineWidth = secProg * 100;//precentage of the section

            //inset line fill progress
            let lineFill = 100 - (secProg * 100);
            this.linePrec = lineFill + '%'; 

            //

            //loop theough each point
                //check which point is the current
                //check by nearest point 
                //currentIndex

            let pointsCount = this.sectionData.items.length;
            let pointProg = secProg * (pointsCount-1);//move between 0-5 (if 5 items)

            //this.currentIndex = "pointProg:"+pointProg;
            
            //console.log("secProg="+secProg);
            if(secProg>0.95)
            {
                this.currentIndex = pointsCount-1;//goto end point
            }
            else
            {
                for(let i=0;i<pointsCount-1;i++){
                    if(pointProg>i && pointProg<i+1){
                        if(i==0 && secProg<0.05){
                            this.currentIndex = -1;//the first 0.05% 
                        }else{
                            this.currentIndex = i;
                        }
                    }
                }
            }            
        },
        updateStyles2()
        {
            //UPDATING ALL THE STYLES OF THE COMPONENT ACCORDING TO THE SCROLL PROGRESS
            //styles[]
            var vm=this;
            if(this.arrTextH.length>0)
            {
                let secProg = this.sectionScrollProg.prog; //precentage of the section
                vm.styles = [];

                for(let i=0;i<this.arrTextH.length;i++)
                {
                    let newH = 0;//
                    let rectH = this.arrTextH[i];                    
                    let partSize = 1/this.arrTextH.length;

                    let itemStart = partSize*i;
                    let itemEnd = itemStart+partSize;                    
                    let delta = itemEnd - secProg;

                    let partProg = 1 - (Math.abs(delta)/partSize);
                    let realPartProg = 1 - (delta/partSize);

                    vm.sectionProgress = this.sectionScrollProg.prog;///////<<<<<<<test

                    newH = rectH*partProg;
                    if(newH>20)
                    {
                        newH+=20;//add for bottom padding of the text
                    }

                    //calculate the alpha according to the distance
                    let newAlpha = 1;
                    //let newAlpha = 0.2 + (partProg * 0.8);
                    //if(newAlpha<0.2){newAlpha=0.2;}

                    //Position of images
                    let positionProgress = realPartProg;
                    if(positionProgress>2){positionProgress=0;}
                    let newImgTrans = 50-((positionProgress*100)/2)-50;

                    //calculate fontSize
                    let minFontSize = 46;
                    let addFontSizeMax = 26;
                    let itemFontSize = minFontSize + (addFontSizeMax*partProg);
                    if(itemFontSize<minFontSize){
                        itemFontSize=minFontSize;
                    }

                    let itemStyle = {
                        partProg:partProg,
                        textH:newH,
                        alpha:newAlpha,
                        imgPos:newImgTrans,
                        imgSize:partProg < 0 ? 0 : partProg,
                        fontSize: itemFontSize
                    };
                    //if(vm.style.length==this.arrTextH.length){
                        //vm.styles[i] = itemStyle;//array is already full, just update the index
                    //}else{
                        vm.styles.push(itemStyle);//array is initlizing
                    //}
                }    
            }
        },
        getLineStyle()
        {                        
            return 'width:'+this.lineWidth+"%";
        },
        getTitleStyle(index)
        {
            if(this.styles.length>0){
                let cssData = this.styles[index];
                return 'opacity:'+cssData.alpha+";font-size:"+cssData.fontSize+"px";
            }
            return '';
        },
        getDescStyle(index)
        {
            if(this.styles.length>0){
                return 'height:'+this.styles[index].textH+'px';
            }
            return '';
        },       
        getInfoPos(index)
        {
            let pointLeft = (91/(this.sectionData.items.length-1))*index;
            //return 'left:calc('+pointLeft+'% + 2.5vw)';
            return '--index:'+index+';left:'+pointLeft+"%";
        },

        getPointPos(index)
        {
            let pointLeft = (100/(this.sectionData.items.length-1))*index;
            return 'left:'+pointLeft+"%";
        },
        scrollImg()
        {
            if(isMobileScreen()){
                //scroll on mobile version
                //let scrollToElement = this.$refs.bnImgScroll1.getElementsByClassName("bnImgItem")[this.selectedIndex];
                //scrollToElement.scrollIntoView({ behavior:'smooth',inline:'center',block:'nearest'});
            }else{
                //fade in/out relevent images on desktop version

            }

        }
    }
};
</script>

